import { createStore } from "vuex";

export default createStore({
  state: {
    user: {
      id: "",
      username: "",
      email: "",
      full_name: "",
      is_super_admin: "",
      image: "",
      createdAt: "",
      updatedAt: "",
      keeplogged: "",
    },
    accountEditor: {
      isOpen: false,
      mode: "viewAdmin",
      requestedrow: null,
      isResetPass: false,
    },
    templateEditor: {
      isOpen: false,
      mode: "viewTemplate",
      requestedrow: null,
    },
    freeEditor: {
      isOpen: false,
      mode: "edit",
      requestedrow: null,
      name: null,
    },
    adminlist: {},
    hideConfigButton: false,
    isPinned: true,
    showConfig: false,
    sidebarType: "bg-white",
    isRTL: false,
    mcolor: "",
    darkMode: false,
    isNavFixed: false,
    isAbsolute: false,
    showNavs: true,
    showSidenav: true,
    showNavbar: true,
    showFooter: false,
    showMain: true,
    isTrusted: true,
    layout: "default",
  },
  mutations: {
    toggleConfigurator(state) {
      state.showConfig = !state.showConfig;
    },
    navbarMinimize(state) {
      const sidenav_show = document.querySelector(".g-sidenav-show");

      if (sidenav_show.classList.contains("g-sidenav-hidden")) {
        sidenav_show.classList.remove("g-sidenav-hidden");
        sidenav_show.classList.add("g-sidenav-pinned");
        state.isPinned = true;
      } else {
        sidenav_show.classList.add("g-sidenav-hidden");
        sidenav_show.classList.remove("g-sidenav-pinned");
        state.isPinned = false;
      }
    },
    sidebarType(state, payload) {
      state.sidebarType = payload;
    },
    navbarFixed(state) {
      if (state.isNavFixed === false) {
        state.isNavFixed = true;
      } else {
        state.isNavFixed = false;
      }
    },
  },
  actions: {
    toggleSidebarColor({ commit }, payload) {
      commit("sidebarType", payload);
    },
  },
  getters: {},
});
